import { registerWebComponents } from './register';
import { parseBrainfishSearch, injectBrainfishInWindow } from './window';

registerWebComponents();

const brainfish = parseBrainfishSearch();

injectBrainfishInWindow(brainfish);

export default brainfish;
